"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _useWindowSize = _interopRequireDefault(require("@commerce-ui/core2/useWindowSize"));
var _useNormalizeAndMapFilters = _interopRequireDefault(require("@deosite/api/hooks/common/useNormalizeAndMapFilters"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _RangePicker = _interopRequireDefault(require("../RangePicker"));
var _Dialog = _interopRequireDefault(require("@commerce-ui/core2/Dialog"));
var _SelectInline = _interopRequireDefault(require("@commerce-ui/core2/SelectInline"));
var _MultiSelectInline = _interopRequireDefault(require("@commerce-ui/core2/MultiSelectInline"));
var _Select = _interopRequireDefault(require("@commerce-ui/core2/Select2"));
var _searchFilterByName = _interopRequireDefault(require("@deosite/helpers/searchFilterByName"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IconArrowDown = function IconArrowDown(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.923 10.263l.848-.849 5.576 5.576 5.576-5.576.848.849-6.424 6.424-6.424-6.424z"
  }));
};
IconArrowDown.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var defaultProps = {
  switchButtonBg: false
};
var FiltersBarDesktop = function FiltersBarDesktop(props) {
  var onChange = props.onChange,
    data = props.data,
    button = props.button,
    buttonMinimal = props.buttonMinimal,
    input = props.input,
    itemRow = props.itemRow,
    itemRowCheckmark = props.itemRowCheckmark,
    _props$switchButtonBg = props.switchButtonBg,
    switchButtonBg = _props$switchButtonBg === void 0 ? defaultProps.switchButtonBg : _props$switchButtonBg;
  var _useNormalizeAndMapFi = (0, _useNormalizeAndMapFilters["default"])({
      data: data,
      onChange: onChange
    }),
    filters = _useNormalizeAndMapFi.filters,
    commit = _useNormalizeAndMapFi.commit;
  var translations = {
    sort: (0, _langLibrary["default"])("Sort"),
    allFilters: (0, _langLibrary["default"])("all filters"),
    from: (0, _langLibrary["default"])("from range"),
    to: (0, _langLibrary["default"])("to range"),
    clear: (0, _langLibrary["default"])("Clear"),
    filter: (0, _langLibrary["default"])("Filter"),
    selected: (0, _langLibrary["default"])("selected"),
    final_price: (0, _langLibrary["default"])("price"),
    price: (0, _langLibrary["default"])("price"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list")
  };
  var buttonContainerMargins = {
    mr: "s5",
    mb: "s7"
  };
  var _useState = (0, _react.useState)(false),
    allFiltersVisible = _useState[0],
    setAllFiltersVisible = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    activeFilterOptions = _useState2[0],
    setActiveFilterOptions = _useState2[1];
  var showAllFilters = function showAllFilters(index, allFiltersVisible) {
    return !allFiltersVisible && index > 4 && setAllFiltersVisible(true);
  };
  var filterOptionsByName = function filterOptionsByName(inputValue, options, filterName) {
    var filteredOptions = (0, _searchFilterByName["default"])(inputValue, options);
    setActiveFilterOptions((0, _defineProperty2["default"])({}, filterName, filteredOptions));
  };
  var size = (0, _useWindowSize["default"])();
  return __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      pb: "s9"
    }
  }, __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexWrap: "wrap",
      width: "85%"
    },
    "data-test": "filters-container-desktop"
  }, filters.filter(function (filter) {
    return filter.id !== "sort";
  }).map(function (filter, index) {
    var _filter$name;
    var stringValue;
    if (filter.isCommittedEmpty) {} else if (filter.type === "multiselect") {
      showAllFilters(index, allFiltersVisible);
      if (filter.committedValue.length === 1) {
        stringValue = filter.committedValue[0].name;
      } else if (filter.committedValue.length > 1) {
        stringValue = "".concat(filter.committedValue.length, " ").concat(translations.selected);
      }
    } else if (filter.type === "range") {
      var _filter$committedValu = filter.committedValue,
        from = _filter$committedValu.from,
        to = _filter$committedValu.to;
      showAllFilters(index, allFiltersVisible);
      if (typeof from === "number" && typeof to === "number") {
        stringValue = "".concat(from, " - ").concat(to);
      } else if (typeof from === "number") {
        stringValue = "".concat(translations.from, " ").concat(from);
      } else if (typeof to === "number") {
        stringValue = "".concat(translations.to, " ").concat(to);
      }
    }
    return __jsx(_Box["default"], {
      sx: filter.isDisabled ? {
        display: "none"
      } : index >= 4 && !allFiltersVisible ? _objectSpread(_objectSpread({}, buttonContainerMargins), {}, {
        display: "none"
      }) : _objectSpread({}, buttonContainerMargins),
      key: filter.id
    }, __jsx(_Dialog["default"], {
      sx: {
        minWidth: "312px"
      },
      button: /*#__PURE__*/_react["default"].cloneElement(button, {
        sx: {
          $outline: true,
          $size: "small",
          $rounded: true,
          $selectable: filter.isCommittedEmpty,
          $switchBg: stringValue ? switchButtonBg : false
        }
      }, [translations[filter.id], stringValue ? " · " : "", stringValue]),
      root: {
        boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
        width: 300,
        bg: "white"
      },
      footer: function footer(_ref) {
        var close = _ref.close;
        return __jsx(_Box["default"], {
          sx: {
            p: "s7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopColor: "neutral",
            borderTopStyle: "solid",
            borderTopWidth: 1
          }
        }, /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
          onClick: function onClick() {
            filter.soft.clearButtonProps.onClick();
            close();
          },
          "data-test": "clear-filter"
        }, translations.clear), /*#__PURE__*/_react["default"].cloneElement(button, {
          sx: {
            $size: "small",
            $switchBg: filter.isDirty
          },
          onClick: close,
          disabled: !filter.isDirty,
          "data-test": "apply-filter"
        }, translations.filter));
      },
      onClose: function onClose() {
        setActiveFilterOptions(false);
        setTimeout(function () {
          return commit();
        }, 1);
      },
      maxHeight: size.height <= 1400 ? 300 : 500
    }, filter.type === "select" && __jsx(_SelectInline["default"], filter.soft.selectProps, itemRow), filter.type === "multiselect" && __jsx(_Box["default"], {
      sx: {
        px: "s7",
        py: "s5"
      }
    }, __jsx(_Box["default"], {
      sx: {
        mb: "s6",
        display: filter.id === "producer" || filter.id === "dajar_collection" ? "block" : "none"
      }
    }, /*#__PURE__*/_react["default"].cloneElement(input, {
      clearable: true,
      onChange: function onChange(e) {
        return filterOptionsByName(e, filter.soft.selectProps.options, filter.name, filter);
      },
      label: filter === null || filter === void 0 ? void 0 : (_filter$name = filter.name) === null || _filter$name === void 0 ? void 0 : _filter$name.toLowerCase()
    })), __jsx(_MultiSelectInline["default"], (0, _extends2["default"])({}, filter.soft.selectProps, {
      options: activeFilterOptions && activeFilterOptions[filter.name] ? activeFilterOptions[filter.name] : filter.soft.selectProps.options
    }), /*#__PURE__*/_react["default"].cloneElement(itemRowCheckmark, {
      color: "active",
      isColor: filter.id === "color_list",
      optionsArray: [],
      allVisible: true
    }))), filter.type === "range" && __jsx(_Box["default"], {
      sx: {
        p: "s7"
      }
    }, __jsx(_RangePicker["default"], (0, _extends2["default"])({}, filter.soft.rangePickerProps, {
      inputFrom: /*#__PURE__*/_react["default"].cloneElement(input, {
        label: translations.from,
        onEnter: function onEnter() {
          return commit();
        }
      }),
      inputTo: /*#__PURE__*/_react["default"].cloneElement(input, {
        label: translations.to,
        onEnter: function onEnter() {
          return commit();
        }
      }),
      separator: __jsx(_Box["default"], {
        sx: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: "s5"
        }
      }, "-")
    })))));
  }), !allFiltersVisible && filters.length > 4 && /*#__PURE__*/_react["default"].cloneElement(button, {
    sx: {
      $outline: true,
      $size: "small",
      $rounded: true,
      $selectable: true
    },
    onClick: function onClick() {
      return setAllFiltersVisible(!allFiltersVisible);
    }
  }, translations.allFilters)), __jsx(_Box["default"], {
    sx: {
      ml: "s6",
      pt: "s5"
    }
  }, filters.find(function (x) {
    return x.id === "sort";
  }) ? __jsx(_Select["default"], (0, _extends2["default"])({
    button: function button(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/_react["default"].cloneElement(buttonMinimal, {
        sx: {
          $size: "small"
        },
        "data-test": "sorting-button",
        rightIcon: __jsx(IconArrowDown, null)
      }, value ? value.label : translations.sort);
    },
    placement: "bottomRight",
    root: {
      boxShadow: "0 0px 14px rgba(0, 0, 0, 0.15)",
      bg: "white",
      width: 250
    },
    selectable: itemRow
  }, filters.find(function (x) {
    return x.id === "sort";
  }).selectProps)) : null)));
};
var _default = FiltersBarDesktop;
exports["default"] = _default;